<mat-button-toggle-group class="mat-button-toggle-group">
  @let arePanelsOpen = arePanelsOpen$ | async;
  <mat-button-toggle
    class="toolbar-button"
    [disabled]="(hasFeedback$ | async) === false"
    [checked]="arePanelsOpen"
    (click)="togglePanel(arePanelsOpen)"
  >
    <mat-icon fontIcon="flag" class="material-symbols-outlined">
      <div *ngIf="hasFeedback$ | async" class="button-badge"></div>
    </mat-icon>
  </mat-button-toggle>
</mat-button-toggle-group>
